import { Box, CardMedia, Typography } from "@mui/material";
import FrameGlassCard from "components/views/frame_glass_card";
import { useNavigate } from "react-router";
import { FrameGlassType } from "utils/other/enums";
import { BoxMotion } from "./material_motion";
import { useState } from "react";

export default function ProjectCard({ index, data }) {
  const navigate = useNavigate();

  const [cover, setCover] = useState("");
  const [errorCover, setErrorCover] = useState(false);

  const getCoverCallback = () => {
    const platform = data.platform.toLowerCase();
    if (platform.includes("android")) {
      return "https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg";
    } else if (platform.includes("mobile")) {
      return "https://upload.wikimedia.org/wikipedia/commons/7/79/Flutter_logo.svg";
    } else if (platform.includes("website")) {
      return "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg";
    } else {
      return "https://upload.wikimedia.org/wikipedia/commons/8/8e/Code_OneDrive_icon.svg";
    }
  };

  return (
    <Box onClick={() => navigate(data.id)}>
      <FrameGlassCard
        type={FrameGlassType.Doff}
        borderRadius="50px"
        outline="2px solid rgba(255, 255, 255, 0.30);"
      >
        <Box
          sx={{
            aspectRatio: 6 / 7,
            padding: errorCover ? {xs: 15, sm:10} : {xs:5, sm:2},
            boxSizing: "border-box",
          }}
        >
          <BoxMotion
            initial={{ opacity: 0, scale: 0, rotate: -180 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ type: "spring", delay: 0.1 * index, duration: 1 }}
            sx={{
              width: "100%",
              height: "100%",
              backgroundImage: `url("${cover}")`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
          <CardMedia
            component="img"
            src={data.cover}
            sx={{ display: "none" }}
            onError={() => {
              setErrorCover(true);
              setCover(getCoverCallback());
            }}
            onLoad={() => setCover(data.cover)}
          />
        </Box>
      </FrameGlassCard>
      <Box height={20} />
      <Typography
        variant="h4"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 600,
          fontSize: 18,
          color: "rgba(0,0,0,0.8)",
          wordWrap: "break-word",
        }}
      >
        {data.name.replace("-", "\u2011")}
      </Typography>
      <Typography
        variant="p"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 500,
          fontSize: 16,
          color: "rgba(0,0,0,0.6)",
        }}
      >
        {data.platform}
      </Typography>
    </Box>
  );
}
